<template>
  <div>
    <!-- <div v-if="data===0" class="title">— {{ $t('common.item1') }} —</div>
    <div v-if="data===1" class="title">— {{ $t('common.item2') }} —</div>
    <div v-if="data===2" class="title">— {{ $t('common.item3') }} —</div> -->
    <div v-for="(item,idx) in 30" :key="idx">
      <span v-if="data===idx">
        — {{ $t('common.item'+(idx+1)) }} —
      </span>
    </div>
  </div>
</template>
<script>
  export default {
    name: "ItemTitle",
    props: {
      data: Number
    }
  };
</script>
<style lang="scss" scope>
  .title {
    font-family: PingFang SC;
    font-size: 32px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 45px;
    letter-spacing: 0;
    color: #333;
    margin-top: 36px;
  }
</style>
